import gql from "graphql-tag";

export default gql`
  fragment ExecutiveCompensationHistoryItemFields on ExecutiveCompensationHistoryItem {
    reportDate
    reportSource
    currency
    salary
    bonus
    otherAnnualCompensation
    restrictedStockAward
    securityUnderlyingOptions
    longTermIncentivePlanPayouts
    optionAward
    nonEquityIncentiveAward
    changeInPensionValue
    allOtherCompensation
    totalCompensation
    maximumPerformanceSharePotential
    calculatedTotal
    forexRate {
      asOfDate
      baseCurrency
      quoteCurrency
      price
    }
  }
`;
